/*
Copyright© Celligence International, LLC - 2024

This software program is protected by copyright laws and is the property of
Celligence International, LLC (Celligence). Any unauthorized reproduction,
distribution, modification, or public display of this program, without the
explicit permission of Celligence is strictly prohibited. If you have gained

access to this program without the expressed approval of Celligence report
the incident to legal@celligence.com.
*/

import useLoanServicing from '../../common/hooks/useLoanServicing';
import { isObjEmptyOrNull, isStrEmptyOrNull } from '../../common/UtilityFunctions';
import { Button } from '@mui/material';
import confirmApplyAEAModal from '../modals/ServicerEscrowAnalysisConfirmModal';
import successOrErrorApplyingAEAModal from '../modals/ServicerEscrowAnalysisResultModal';
import Styles from '../../css/ServicerEscrowAnalysis.module.css';
import { useApplyAEAContext } from '../../contexts/ApplyAEAContext';
import LoadingModal from '../modals/LoadingModal';

const ApplyAEAView = () => {
  const { loanServicing } = useLoanServicing();

  const { applyingAEA, applyAEAClicked, setApplyAEAClicked, applyAEAResultRetrieved } = useApplyAEAContext();

  const aeaAudit = !isObjEmptyOrNull(loanServicing) && 'aeaAudit' in loanServicing && loanServicing.aeaAudit;

  const aeaAuditText = () => {
    const aeaAuditText = !aeaAudit
      ? 'Apply AEA disabled. To enable, set the AEA Audit flag to Yes in the Loan Information screen.'
      : '';
    return !isStrEmptyOrNull(aeaAuditText) && <p className={Styles.aeaaudittext}>{aeaAuditText}</p>;
  };

  const applyButton = () => {
    const disabled = applyingAEA || applyAEAClicked || applyAEAResultRetrieved;
    return (
      aeaAudit && (
        <div className={Styles.applybutton}>
          <Button
            fullWidth
            className={disabled ? '' : Styles.bluebutton}
            variant='outlined'
            size='large'
            disabled={disabled}
            onClick={() => {
              setApplyAEAClicked(true);
            }}
          >
            {'Apply New Payment'}
          </Button>
        </div>
      )
    );
  };

  return (
    <>
      {applyButton()}
      {aeaAuditText()}
      {confirmApplyAEAModal()}
      {successOrErrorApplyingAEAModal()}
      {applyingAEA && <LoadingModal open={true}></LoadingModal>}
    </>
  );
};

export default ApplyAEAView;
